class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.toggleCategoryReminder();
  }

  toggleCategoryReminder(){
    $('body').on('click', '[category-reminder-toggler]', function(){
      $('.cart-drawer_category-reminder').toggleClass('open');
    })
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (cartLink.getAttribute('aria-disabled') === 'true') return;
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    // The ordered-categories panel hangs off the drawer's edge and its toggler goes
    // with it, so leaving it open would mean re-opening the drawer to a panel the
    // customer never asked for.
    this.querySelector('.cart-drawer_category-reminder')?.classList.remove('open');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  // handle order grid details
  getItemCountSubtotal(source){
    const html = new DOMParser().parseFromString(source, 'text/html')

    const items = html.querySelector('.mrMiniCart-header-count');
    const subtotal = html.querySelector('.subtotal .mrMiniCart-conclustionItem-value');

    const destination_items = document.querySelector('.cart__item_count');
    const destination_subtotal = document.querySelector('.cart__total_price');
    
    // Guard both source and destination — destination elements only exist on
    // collection pages (facets.liquid), not on PDP or other templates.
    if( items && destination_items ){
      destination_items.innerHTML = items.innerHTML;
    }
    if( subtotal && destination_subtotal ){
      destination_subtotal.innerHTML = subtotal.innerHTML;
    }
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

      console.log('section.id', section.id)
      if( section.id == 'cart-drawer'){
        this.getItemCountSubtotal(parsedState.sections[section.id]);
      }
    }));

    // COB2B-787: this replaces .drawer__inner outright, so anything applied on top of
    // Liquid's render is gone — the checkout gate's disabled buttons and its notice
    // included. CartItems.updateQuantity already announces its own re-render this way
    // and this path is the other half of it: every add-to-cart entry point
    // (product-form.js, the card/search/homepage adders, your-lists) lands here and
    // announced nothing, so the mini-cart silently unblocked on the most common route
    // to it. Raised on the shared event rather than a new one so the existing
    // listeners — creditBalanceGate.js, the free-shipping message — pick it up
    // unchanged. Fired after the sections are in the DOM, so a listener that reads
    // markup sees the new markup.
    $(window).trigger('cart:quantity-update');

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
